<template>
  <!-- Figma S&R flow stepper (e.g. 5549:4055 / 5657:1309): white bar, 28px circles, 70px connectors.
       Below laptop (Figma mobile 5908-2374): a numbers-only pill. Below 1280 only the current step keeps its label, so it fits next to the aside (QA D-38). -->
  <div
    class="flex justify-center w-full bg-white border-1 border-[#E9ECF1] rounded-full laptop:rounded-[12px] py-[10px] laptop:py-[18px] px-[16px] laptop:px-[26px]">
    <ol class="flex items-center m-0 p-0 list-none">
      <li v-for="(label, index) in steps" :key="label" class="flex items-center">
        <span class="flex items-center gap-[10px]">
          <span
            class="w-[24px] h-[24px] laptop:w-[28px] laptop:h-[28px] flex-shrink-0 rounded-full flex items-center justify-center text-[13px] font-medium font-roboto"
            :class="index + 1 < step ? 'bg-[#1FA971]' : (index + 1 == step ? 'bg-[#6C79E0] text-white' : 'bg-white border-[1.5px] border-[#D3D8E2] text-[#9CA3AF]')">

            <svg v-if="index + 1 < step" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 64 64">
              <path d="M0 0h64v64H0z" fill="none" />
              <path fill="#fff" d="M56 2L18.8 42.909L8 34.729H2L18.8 62L62 2z" />
            </svg>
            <template v-else>{{ index + 1 }}</template>
          </span>
          <span class="text-[14px] leading-[20px] font-roboto whitespace-nowrap" :class="[index + 1 < step ? 'text-[#1FA971]' : (index + 1 == step ? 'text-[#2E3138] font-medium' : 'text-[#9CA3AF]'),
          { 'hidden desktop:inline': index + 1 != step, 'hidden laptop:inline': index + 1 == step }]">{{ label
          }}</span>
        </span>
        <span v-if="index < steps.length - 1"
          class="w-[38px] laptop:w-[24px] desktop:w-[50px] largeDesktop:w-[70px] h-[2px] flex-shrink-0"
          :class="index + 1 < step ? 'bg-[#1FA971]' : 'bg-[#DFE3EA]'" />
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  props: {
    // 1-based current step
    step: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      steps: ['Select Unit', 'Equipment Diagnosis', 'Summary', 'Finalize', 'Review & Submit'],
    };
  },
};
</script>
